type FormBasicDetails = {
  Facility__c?: string;
  Resident__c?: string;
} | null;
export function getFormBasicDetails(
  facilityId: string,
  residentId: string,
  selectedIncident: any,
  userFacilities: any
): FormBasicDetails {
  let formBasicDetails: FormBasicDetails = null;

  if (facilityId && residentId) {
    formBasicDetails = {
      Facility__c: facilityId,
      Resident__c: residentId,
    };
  }
  if (selectedIncident) {
    formBasicDetails = {
      Facility__c: selectedIncident?.Facility__c,
      Resident__c: selectedIncident?.Resident__c,
    };
  }

  const userFacility = userFacilities.find(
    (facility: { facilityId: string }) => facility.facilityId === facilityId
  );

  if (!selectedIncident && userFacility && userFacility.roleName === "Guest") {
    formBasicDetails = {
      Facility__c: facilityId,
    };
  }

  return formBasicDetails;
}
